import * as type from './types'
import actions from './actions'
import getters from './getters'
import { generalHelpers } from '@/_helpers'

const state = {
  shipmentExportDetails: [],
  selectedShipment: null,
  isFetching: false,
  errors: [],
  transport: null,
  dropUnitsHash: {},
  dropUnitsHashKeys: {},
  filteredByOrderRef: [],
  filteredByCustomerRef: [],
  sortedBy: null,
  quotes: []
}

const mutations = {
  [type.SET_EXPORT_SHIPMENT] (state, action) {
    state.shipmentExportDetails.push(action.shipment)
  },
  [type.SET_EXPORT_SHIPMENT_CONTEXT](state, action) {
    state.selectedShipment = action.shipment
    // if (state.selectedShipment != null) {
    //   if (state.selectedShipment.id === action.shipment.id) {
    //     state.selectedShipment = { ...state.selectedShipment, ...action.shipment }
    //   } else {
    //     state.selectedShipment = action.shipment
    //   }
    // } else {
    //   state.selectedShipment = action.shipment
    // }
  },
  [type.SHIPMENT_FETCHING] (state, action) {
    state.isFetching = action.isFetching
  },
  [type.SHIPMENT_ERROR] (state, action) {
    state.errors.push(action.errors)
  },
  [type.SHIPMENT_CLEAR_ERROR] (state) {
    state.errors = []
  },
  [type.CLEAR_SHIPMENT] (state) {
    state.selectedShipment = null
  },
  [type.TRANSPORT_CLEAR_ERROR] (state) {
    state.errors = []
  },
  [type.TRANSPORT_FETCHING] (state, action) {
    state.isFetching = action.isFetching
  },
  [type.CLEAR_TRANSPORT] (state) {
    state.transport = null
  },
  [type.SET_TRANSPORT] (state, action) {
    state.transport = action.transport
  },
  [type.TRANSPORT_ERROR] (state, action) {
    state.errors.push(action.errors)
  },
  [type.DROP_FETCHING] (state, action) {
    state.isFetching = action.isFetching
  },
  [type.DROP_ERROR] (state, action) {
    state.errors.push(action.errors)
  },
  [type.DROP_CLEAR_ERROR] (state) {
    state.errors = []
  },
  [type.ADD_DROP_UNITS] (state, action) {
    Object.keys(state.dropUnitsHash).forEach((key) => {
      delete state.dropUnitsHash[key]
    })
    Object.keys(state.dropUnitsHashKeys).forEach((key) => {
      delete state.dropUnitsHashKeys[key]
    })
    let allUnits = []
    if (action.isTree) {
      allUnits = [...action.units, ...action.units.reduce(
        (arr, elem) => {
          for (const c of elem.children) {
            if (c.children !== undefined) {
              for (const a of c.children) {
                arr.push(a)
              }
            } else {
              for (const a of c.units) {
                arr.push(a)
              }
            }
            arr.push(c)
          }
          return arr
        }, []
      )]
    } else {
      allUnits = [...action.units]
    }
    allUnits.forEach((unit) => {
      unit.children = []
      // Create unit order reference number
      if (unit.items !== null) {
        unit.items.forEach((item) => {
          // item.orderRef = item.ref.replace(/-\d*/g, '')
          if (unit.transport.order != null) {
            item.orderRef = unit.transport.order.seller.ref
          } else {
            item.orderRef = null
          }
        })
      }
      state.dropUnitsHash = { ...state.dropUnitsHash, [unit.id]: unit }
    })
    const hashKeyGroups = generalHelpers.groupByObjects(allUnits, 'parent')
    Object.keys(hashKeyGroups).forEach((key) => {
      state.dropUnitsHashKeys = { ...state.dropUnitsHashKeys, [key]: hashKeyGroups[key].map(({ id }) => id) }
    })
  },
  [type.EXPORT_QUOTE_LIST_CLEAR_ERROR] (state) {
    state.errors = []
  },
  [type.EXPORT_QUOTE_LIST_FETCHING] (state, action) {
    state.isFetching = action.isFetching
  },
  [type.EXPORT_QUOTE_LIST_ERROR] (state, action) {
    state.errors.push(action.errors)
  },
  [type.EXPORT_SET_QUOTE_LIST] (state, action) {
    state.quotes = action.quote
  },
  [type.EXPORT_CLEAR_QUOTE_LIST] (state) {
    state.quotes = []
  }
}

export const exportData = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}